// Zoom levels for waveform display
export const ZOOM_LEVELS = [256, 512, 1024, 2048, 4096];

export const SAMPLES_PER_PIXELS = 256;

// Default zoom index (which level to start at)
export const DEFAULT_ZOOM_INDEX = 2; // Middle index (1024)

/** Common loudness targets for podcasts and streaming platforms (LUFS). */
export const LUFS_PRESETS = [-23, -19, -16, -14, -12] as const;
export const DEFAULT_TARGET_LUFS = -16;
